module.exports = __webpack_public_path__ + "img/9.4ccae2e6.webp";